import * as eachTemplateDefaultData from '@/config/eachTemplateDefaultData'

export default {
  state: () => {
    // 当前选中的模版ID
    let currentTemplateId = 'freshTemplate'
    // 当前选择模版数据
    let currentTemplateData = []
    console.log('----默认数据', currentTemplateData)
    return {
      // 当前选择模版的门店信息
      currentTemplateStoreInfo: {
        brandName: '', // 品牌名称
        storeId: '', // 生活圈门店id
        storeName: '',
        qrorderStoreId: '', // 扫码点单
        isOnline: '',
        marketingActivity: '',
        open: '',
        customerAddFriend: '',
        address: '',
        assistantGrant: '',
        storeLogo: '',
        brandLogo: '' // 品牌logo
      },
      currentTemplateId,
      currentTemplateData,
      cacheTemplateData: {
        moduleType: '',
        moduleData: {}
      }, // 模版的暂存区，用于在编辑某个模块的时候，数据存储；最终保存后再赋值
      cachePathData: {
        menuIcon: '', // 菜单图标链接
        menuName: '', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        path: '', // 菜单链接
        name: '' // 菜单链接名称
      }, // 路径选择的暂存区，用于在编辑某个路径的时候，数据存储；如果中途取消进行还原
      templateCodeVersion: { // 店铺装修功能对应的模版小程序版本
        alipayCodeVersion: '', // 需要的支付宝版本
        wxCodeVersion: '', // 需要的微信版本
        tip: 2 // 1-提示；2-不提示
      },
      customProduct: {
        isDefault: true, // 标记是否是默认 非默认情况下不需要请求数据
        showMode: 1, // 1-系统默认 2-商户自定义
        limit: 20, // 商品最大数量 默认20
        goodsList: [], // 商品列表
        editGoods: null,
        cache: null
      }
    }
  },
  getters: {
    currentTemplateStoreInfo: state => state.currentTemplateStoreInfo,
    // 当前选中的模版ID
    currentTemplateId: state => state.currentTemplateId,
    // 当前选择模版数据
    currentTemplateData: state => state.currentTemplateData,
    cacheTemplateData: state => state.cacheTemplateData,
    cachePathData: state => state.cachePathData,
    templateCodeVersion: state => state.templateCodeVersion,
    customProduct: state => state.customProduct
  },
  mutations: {
    /**
     * @function 切换模版，并且重制模版的基础数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    modifyCurrentTemplateStoreInfo (state, data) {
      state.currentTemplateStoreInfo = {
        ...state.currentTemplateStoreInfo,
        ...data
      }
    },
    /**
     * @function 切换模版，并且重制模版的基础数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    switchTemplateMutation (state, data) {
      state.currentTemplateId = data.templateId
      let storeInfo = state.currentTemplateData[0]
      state.currentTemplateData = [
        ...eachTemplateDefaultData[`${data.templateId}DefaultData`]
      ]
      // 切换模版之后店铺信息需要保存
      if (storeInfo) {
        state.currentTemplateData[0] = { ...storeInfo }
      }
    },
    /**
     * @function 创建模版数据，用于切换模版更新数据或者空模版进入的时候
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    createTemplateDataMutation (state) {
      let storeInfo = state.currentTemplateData[0]
      state.currentTemplateData = [
        ...eachTemplateDefaultData[`${state.currentTemplateId}DefaultData`]
      ]
      // 切换模版之后店铺信息需要保存
      if (storeInfo) {
        state.currentTemplateData[0] = { ...storeInfo }
      }
    },
    /**
     * @function 当保存了或者退出后，清除模版数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    clearTemplateDataMutation (state) {
      state.currentTemplateData = []
    },
    /**
     * @function 修改模版数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    modifyTemplateDataMutation (state, data) {
      // 如果type为editAll，表示整个数据都替换；不然则替换部分
      if (data.type === 'editAll') {
        state.currentTemplateData = data.moduleData
        return false
      }

      let templateData = [
        ...state.currentTemplateData
      ]
      templateData[data.editModuleIndex] = data.moduleData

      state.currentTemplateData = templateData
    },
    /**
     * @function 修改暂存的模版数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    modifyCacheTemplateDataMutation (state, data) {
      state.cacheTemplateData = {
        ...state.cacheTemplateData,
        ...data
      }
    },
    /**
     * @function 清除模版暂存区数据
     * @param {*} state state树
     */
    clearCacheTemplateDataMutation (state) {
      state.cacheTemplateData = {
        moduleType: '',
        moduleData: {}
      }
    },
    /**
     * @function 修改暂存的路径数据
     * @author eleven
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    modifyCachePathDataMutation (state, data) {
      state.cachePathData = {
        ...state.cachePathData,
        ...data
      }
    },
    /**
     * @function 清除路径选择暂存区数据
     * @param {*} state state树
     */
    clearCachePathDataMutation (state) {
      state.cachePathData = {
        menuIcon: '', // 菜单图标链接
        menuName: '', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        path: '', // 菜单链接
        name: '' // 菜单链接名称
      }
    },
    /**
     * @function 店铺装修功能对应的模版小程序版本
     * @author wfshao
     * @param {object} state state树
     * @param {object} data 传递来的参数
     */
    modifyTemplateCodeVersion (state, data) {
      state.templateCodeVersion = {
        ...state.templateCodeVersion,
        ...data
      }
    },
    /**
     * @function 修改店铺大家都在抢商品信息
     */
    setCustomProduct (state, data) {
      state.customProduct = {
        ...state.customProduct,
        ...data
      }
    }
  }
}
